"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralLedgerEntryTypeEnum = void 0;
var ReferralLedgerEntryTypeEnum;
(function (ReferralLedgerEntryTypeEnum) {
    ReferralLedgerEntryTypeEnum["Pending"] = "pending";
    ReferralLedgerEntryTypeEnum["Earned"] = "earned";
    ReferralLedgerEntryTypeEnum["Used"] = "used";
    ReferralLedgerEntryTypeEnum["Canceled"] = "canceled";
})(ReferralLedgerEntryTypeEnum = exports.ReferralLedgerEntryTypeEnum || (exports.ReferralLedgerEntryTypeEnum = {}));
//# sourceMappingURL=referral-ledger-entry-type-enum.js.map